import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PHONE = "8787889275";
export const PHONE_INTL = "918787889275";
export const EMAIL = "rentacarkohima@gmail.com";
export const ADDRESS = "RAC-K, Agri-Electrical Colony, Near Stella Higher Secondary School, Kohima, Nagaland";
export const HOURS = "Open Daily · 8:00 AM – 7:00 PM";
export const MAP_URL = "https://maps.app.goo.gl/Y6Y3D2QUwSeRTe8m8";
export const INSTAGRAM_DEFAULT = "https://www.instagram.com/rentabikekohima/?hl=en";

export const waLink = (text) =>
  `https://wa.me/${PHONE_INTL}?text=${encodeURIComponent(text || "Hi Rent A Car Kohima, I'd like to enquire about a vehicle rental.")}`;

export const telLink = `tel:+${PHONE_INTL}`;

export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${BACKEND_URL}${url}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CTA_IMG =
  "https://static.prod-images.emergentagent.com/jobs/497d2256-dbb0-46e3-a3cc-3ea7112b408b/images/e0c84d0599800ca4ab780b384b0344ff15b76064e2b269e338e9e86970b11498.jpeg";
export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/497d2256-dbb0-46e3-a3cc-3ea7112b408b/images/9a82b7728dc35503c7ad258737d0fbc770318261d7ac48f1d47059a6fb9d5d66.jpeg";
export const CARS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/497d2256-dbb0-46e3-a3cc-3ea7112b408b/images/8d1a348871f5f27c93d0d39244d702f5b83be51c7ded521c543958c4f3718610.jpeg";
export const BIKES_IMG =
  "https://static.prod-images.emergentagent.com/jobs/497d2256-dbb0-46e3-a3cc-3ea7112b408b/images/5a39ffe8efdf40f2170a4d3cc23e666d845f539f289d47c1a5c325b667d25a6d.jpeg";
